import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@/contexts/AuthContext";
import { getCurrentClinicCustomerId } from "@/lib/utils/clinic-context";
import { CURRENT_CLINIC_CUSTOMER_ID_QUERY_KEY } from "@/lib/react-query/queryKeys";

/**
 * Cached React Query hook for the current clinic's customer_id.
 * Use this instead of calling getCurrentClinicCustomerId() inside queryFns
 * so auth + profile + clinic are fetched once and shared across all dependent queries.
 */
export function useCurrentClinicCustomerId() {
  const { user } = useAuth();

  return useQuery({
    queryKey: CURRENT_CLINIC_CUSTOMER_ID_QUERY_KEY,
    queryFn: () => getCurrentClinicCustomerId(),
    enabled: !!user,
    staleTime: 5 * 60 * 1000, // 5 min
    gcTime: 10 * 60 * 1000, // 10 min
    refetchOnWindowFocus: false,
  });
}
